import { z } from 'zod'

export const SUPPORTED_LOCALES = ['en', 'ko'] as const
export const localeSchema = z.enum(SUPPORTED_LOCALES)
export type Locale = z.infer<typeof localeSchema>
export const DEFAULT_LOCALE: Locale = 'en'

/** 5 GiB; keep it at or below the backend's own upload limit. */
export const DEFAULT_DATASET_UPLOAD_MAX_BYTES = 5 * 1024 ** 3

/**
 * Runtime configuration served as `/config.json` and mounted per deployment.
 * Unknown keys are ignored so newer config files do not break older builds.
 */
export const runtimeConfigSchema = z.object({
  apiBaseUrl: z.string().min(1),
  /** Leave out until the backend offers a WebSocket: no realtime connection is attempted then. */
  wsBaseUrl: z.string().min(1).optional(),
  locale: localeSchema.default(DEFAULT_LOCALE),
  enabledModules: z.array(z.string().min(1)).default([]),
  kiosk: z.object({
    idleTimeoutSec: z.number().int().positive(),
  }),
  tv: z.object({
    rotationIntervalSec: z.number().int().positive(),
  }),
  /** Largest dataset file the upload popup accepts; the backend enforces its own limit as well. */
  datasetUpload: z
    .object({
      maxFileSizeBytes: z.number().int().positive(),
    })
    .default({ maxFileSizeBytes: DEFAULT_DATASET_UPLOAD_MAX_BYTES }),
})

export type RuntimeConfig = z.infer<typeof runtimeConfigSchema>
